import { getEntityRef } from "@client/content/lib/helper";
import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { type RootContainerProps } from "@client/content/types";
import ExpandableSearch, {
  type ExpandableSearchActionProps,
  type ExpandableSearchMapProps
} from "@client/controls/Inputs/Search/Expandable/component";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type EntityRef } from "@client/types";
import { setSearchText } from "../../../actions";

const makeMapStateToProps = () => {
  const fieldStyleSelector = makeFieldStyleSelector();

  return (state: AppState, props: EntityRef): ExpandableSearchMapProps => {
    return {
      ...props,
      style: fieldStyleSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ExpandableSearchActionProps => ({
  onSearch: (value: string) => dispatch(setSearchText(getEntityRef(props), value)),
  onClear: () => dispatch(setSearchText(getEntityRef(props), null))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(ExpandableSearch);
